import $ from 'jquery';
import { eventTypes } from '../constants';
import { getError, servletSave } from './helpers';
import join from 'url-join';
import crud from './helpers/crud';

const ACCOUNT_UPDATE_QUERY_PARAMS = [ 'location', 'locationName', 'scheduled', 'durationMinutes', 'note' ];
const USER_UDPATE_QUERY_PARAMS = [ 'flagged', 'attended', 'color' ];

export default class EventDAO extends crud {

  constructor(urls) {
    super(urls.EVENTS_URL);
    this._url = urls.EVENTS_URL;
    this.EVENT_DATA_UPDATE_URL = urls.EVENT_DATA_UPDATE_URL;
  }

  merge = ({ primary, others }) => {
    if (typeof primary !== 'string' || !_.isArray(others) || !_.all(others, other => typeof other === 'string')) {
      return Promise.reject(new Error('Invalid parameters'));
    }

    return servletSave(join(this._url, 'merge'), { primary, others });
  };

  /**
   * save an event
   * @param eventParams (Event shape)
   * @param accountId (Number)
   * @returns {Promise}
   */
  save = (eventParams, accountId) => {
    let eventId;

    // get appropriate handler
    switch (eventParams.eventType) {
      case eventTypes.GAME:
      case eventTypes.SCHOOL_GAME:
        eventId = eventParams.id;
        return this.update(eventParams, accountId).then(() => this.getSingle(eventId));

      case eventTypes.RECRUIT_APPOINTMENT:
      case eventTypes.TOURNEY_APPOINTMENT:
        return servletSave(this._url, { ...eventParams, accountId })
          .then(event => {
            eventId = event.id;
            return this.update({ ...eventParams, id: event.id }, accountId);
          })
          .then(() => this.getSingle(eventId));

      default:
        return Promise.reject(new Error(`Unhandled event type: ${eventParams.eventType}`));
    }
  };

  /**
   * update user event data
   * @param event (Object)
   * - id: event id (String)
   * - accountEventData: account level updates (Array)
   * - accountUserEventData: user level updates (Array)
   * @param accountId (Number)
   * @returns {*}
   */
  update = (event, accountId) => {
    const { id: eventId, accountEventData, accountUserEventData } = event;
    const users = _.chain(accountUserEventData).indexBy(ued => ued.userId || ued.userDetails.id).value();
    const updates = [ { eventId, accountUpdates: _.first(accountEventData), users } ];

    return new Promise((resolve, reject) => {
      const fixedUpdates = _.map(updates, ({ eventId, accountUpdates, users }) => {
        return {
          eventId,
          accountUpdates: _.pick(accountUpdates, ACCOUNT_UPDATE_QUERY_PARAMS),
          users: _.mapObject(users, fields => _.pick(fields, USER_UDPATE_QUERY_PARAMS))
        };
      });

      $.ajax({
        method: 'POST',
        contentType: 'application/json',
        url: this.EVENT_DATA_UPDATE_URL,
        data: JSON.stringify({ accountId, updates: fixedUpdates })
      }).then((resp) => {
        resolve(resp);
      }, (jqXhr) => {
        reject(getError(jqXhr, 'Failed to update Event Data.'));
      });
    })
      .then(() => this.getSingle(eventId));
  };
}




// WEBPACK FOOTER //
// ./src/js/util/dao/EventDAO.js